<template>
    <div class="container-fluid">
        <h1>Welcome to User Settings Page</h1>
    </div>
</template>

<script>
export default {
  
}
</script>




// WEBPACK FOOTER //
// UserSettings.vue?2302dafc